import * as React from "react"

import { isNumber } from "../../../../../../util/Strings"

import UnavailableLink from "../UnavailableLink"

import Collection from "./Collection"
import CollectionInWorkspace from "./CollectionInWorkspace"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    linkParameters: string[]
}

export const CollectionInternalLink = ({
    attributes,
    customLabel,
    label,
    linkParameters,
}: Props): JSX.Element => {
    if (linkParameters.length === 2 && isNumber(linkParameters[1])) {
        // SMARTLIST.[SMARTLISTID] => OPENS THE GIVEN SMARTLIST
        return (
            <Collection
                attributes={attributes}
                customLabel={customLabel}
                label={label}
                collectionId={parseInt(linkParameters[1])}
            />
        )
    } else if (
        // SMARTLIST.[WORKSPACEID].[SMARTLISTID] => OPENS THE GIVEN SMARTLIST IN THE GIVEN WORKSPACE
        linkParameters.length === 3 &&
        isNumber(linkParameters[1]) &&
        isNumber(linkParameters[2])
    ) {
        return (
            <CollectionInWorkspace
                attributes={attributes}
                customLabel={customLabel}
                label={label}
                workspaceId={parseInt(linkParameters[1])}
                collectionId={parseInt(linkParameters[2])}
            />
        )
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default CollectionInternalLink
